export const IND_TIPO_RECIBO_DIC = {
  C: "Copago" as "Copago",
  P: "Prima" as "Prima",
  AD: "Adeudo" as "Adeudo",
};

export const STATUS_DIC = {
  PP: "Pendiente Pago" as "Pendiente Pago",
  PA: "Pendiente Actualización" as "Pendiente Actualización",
  R: "Realizado" as "Realizado",
  N: "No realizado" as "No realizado",
  C: "Cancelado" as "Cancelado",
};

export const SUBSTATUS_DIC = {
  GP: "Generación de Pedido" as "Generación de Pedido",
  EL: "Envio de landing de pago" as "Envio de landing de pago",
  RL: "Redirección a landing de pago" as "Redirección a landing de pago",
  IL: "Intento de pago landing" as "Intento de pago landing",
  EP: "Error en el pago con landing" as "Error en el pago con landing",
  PL: "Pago correcto con landing" as "Pago correcto con landing",
};

// Guardas de typescript
export function isKeyOfTipoRecibo(key: string): key is keyof typeof IND_TIPO_RECIBO_DIC {
  return key in IND_TIPO_RECIBO_DIC;
}

export function isKeyOfStatus(key: string): key is keyof typeof STATUS_DIC {
  return key in STATUS_DIC;
}

export function isKeyOfSubestatus(key: string): key is keyof typeof SUBSTATUS_DIC {
  return key in SUBSTATUS_DIC;
}
